import { isToday } from "date-fns";
import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseTimelineDate } from "web_myplann/NotificationCenter/Utils/parseTimelineDate";

export const isResolvedActivityMovedToToday = (
	item: TimelineItemResponseDTO,
): boolean =>
	item.category === TimelineItemCategoryEnum.Activity &&
	item.isResolved &&
	!item.time &&
	isToday(parseTimelineDate(item.date));
